import type { TFunction } from 'i18next'
import { useTranslation } from 'react-i18next'

import LabeledTextField from '@/components/dataDisplay/LabeledTextField'
import environment from '@/environment'
import type { ControllerConfigVersion } from '@/features/controller/configuration/types'

type ConfigAuthorInfoProps = {
  configVersion: ControllerConfigVersion
}

export function renderConfigAuthor(configVersion: ControllerConfigVersion, t: TFunction) {
  // BFF redacts createdByUsername / createdByUserEnvironment / createdByUserId to `null` for non-
  // admin callers; @JsonInclude(NON_NULL) then drops them from the wire payload entirely, so the
  // fields land here as `undefined`. Fall back to a generic label instead of concatenating
  // `undefined` into the text.
  if (!configVersion.createdByUsername) {
    return t('controllers.configuration.version.updated_by_redacted')
  }

  const maybeEnvironment =
    // show the environment name if the user comes from a different environment
    configVersion.createdByUserEnvironment && configVersion.createdByUserEnvironment !== environment.environmentName
      ? ` (${configVersion.createdByUserEnvironment})`
      : ''

  return configVersion.createdByUsername + maybeEnvironment
}

export function ConfigAuthorInfo({ configVersion }: Readonly<ConfigAuthorInfoProps>) {
  const { t } = useTranslation()

  return (
    <LabeledTextField
      label={t('controllers.configuration.version.updated_by')}
      text={renderConfigAuthor(configVersion, t)}
    />
  )
}
